import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthEventService {
  private _forceLogoutSubject = new Subject<void>();

  public forceLogout$ = this._forceLogoutSubject.asObservable();

  public triggerForceLogout(): void {
    this._forceLogoutSubject.next();
  }
}
